import script from "./NavComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NavComponent.vue?vue&type=script&setup=true&lang=js"

import "./NavComponent.vue?vue&type=style&index=0&id=6f7be1c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f7be1c2"]])

export default __exports__